import PropTypes from 'prop-types'
import React from 'react'
import config from 'SRC/config/config.yaml'

export const LocationLimit = ({packages}) => {
  const text = config.registrationForm.package.locationLimit
  return <tr>
    <td>{text[0]} <strong>{text[1]}</strong> {text[2]}</td>
    {
      packages.map(item => <td key={item.id}>{Number(item.locationLimit)}</td>)
    }
  </tr>
}
LocationLimit.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    locationLimit: PropTypes.number
  })).isRequired
}

LocationLimit.defaultProps = {
  packages: []
}
